import gql from 'graphql-tag';

export default gql`
mutation deleteForm($obj: DeleteFormInput!) {
  deleteForm(object: $obj) {
    deletedForm
  }
}
`;
